/*
  - TODO LIST
  - Children filters ability and determine how challenging or simpler it will be - OnHold
  - create FilterLanding Page which will make necessary API request to pull data, currently NominationHome makes all request which is not good -OnHold
  - Grid system for filter rendering as per design https://www.figma.com/proto/FmXv4QmPfjAZK0mhdJ93QB/ORIM-Nomination-tool?node-id=420%3A2683&scaling=min-zoom&page-id=2%3A97&starting-point-node-id=420%3A2683
  - Tooltip & pinned Icon display
  - Add Custom Category - Done
  - Relative Dates for Calendar 
  - Author dropdown is closing after one selection, not happening on Staging so need to find out why
  - Try https://hypeserver.github.io/react-date-range/ for date picker - Tried, not useful
*/

//Always return sorted array by GroupBy field
export const TRIGGERTITLE_FILTERS = () => {
  //return orderBy(FILTERS, item => item.groupBy, ['asc']);
  return FILTERS;
};

let FILTERS = [
  {
    groupBy: 'Title Metadata',
    name: 'Already Downpriced',
    parentId: 'XP292KjehJTMs2ut',
    tooltip: 'Searches for books which is already downpriced',
    renderNATypes: false,
    isFrequentlyUsed: true,
    isRelativeChildFilters: true,
    isRelativeToTriggerSchedule: true,
    selectedValueInfo: 'Filter Date Range is from [[startDate]] to [[endDate]]',
    isDownPricedFilter: true,
    collection: 'campaigngrid',
    field: 'daterange-limited',
    comparisonOperator: '$or',
    type: 'date',
    shortCode: 'arg1',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'Mz3d3kCaNj_Hw8aX',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'relative_days',
        collection: 'campaigngrid',
        filterLabel: 'Relative Days to Trigger Schedule',
        placeholder: 'Relative Days to Trigger Schedule',
        tooltip: 'Searches for books based on title input',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'QZ2RHaa7FcHJmvkT',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'consecutive_days',
        collection: 'campaigngrid',
        filterLabel: 'Consecutive Days',
        placeholder: 'Consecutive Days',
        tooltip: 'Searches for books based on title input',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'XSdH2Cm4fsUHaID',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'regex',
        field: 'promotedtitles.countries',
        collection: 'campaigngrid',
        placeholder: 'Select Territories',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'Pp7rKd3mQx2LsT9v',
        filterLabel: 'Promo Price',
        comparisonOperator: '$eq',
        type: 'Range',
        field: 'promotedtitles.promoprice',
        collection: 'campaigngrid',
        placeholder: 'e.g. 1.99 or 0 to 2.99',
        tooltip: 'Only include down priced titles whose promo price matches this value or range',
        controlType: { name: 'inputbox', isRequired: false, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'Yaask182-y1S1k2Dh',
        filterLabel: 'Include Activation titles',
        comparisonOperator: '$eq',
        type: 'boolean',
        field: 'includeActivationTitles',
        collection: 'books',
        placeholder: 'Boolean',
        controlType: { name: 'toggle', label: 'Include Activation titles' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Priority Title Report difference in number',
    parentId: '-7ncKj78yMZSOjps',
    tooltip: 'Last six month and prior to last six month difference sale in dollar',
    renderNATypes: false,
    isFrequentlyUsed: true,
    shortCode: 'arg2',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'yGbSvZeYRk8mHEkq',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'calculatedHistoricalData.differenceInNumber',
        collection: 'aggregatedhistoricaldata',
        filterLabel: '',
        placeholder: 'Enter value',
        tooltip: 'Searches for books based on title input',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Search Title Name',
    parentId: 'g57tPjVSJ5YaWup8',
    tooltip: 'Searches for books based on title input',
    renderNATypes: false,
    isFrequentlyUsed: true,
    shortCode: 'arg4',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'RIoUzxQ5lT18N99W',
        comparisonOperator: '$regex',
        type: 'regex',
        field: 'title',
        collection: 'books',
        filterLabel: '',
        placeholder: 'String',
        tooltip: 'Searches for books based on title input',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Authors',
    parentId: 'pRbdNy-m2C30VKJO',
    tooltip: 'Searches against Authors',
    renderNATypes: false,
    isFrequentlyUsed: true,
    shortCode: 'arg5',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'ttl5u9jG0vweCm10',
        filterLabel: '',
        collection: 'books',
        placeholder: 'Select Author(s)',
        comparisonOperator: '$elemMatch',
        type: 'Array',
        field: 'authors',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: false, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Keywords',
    parentId: 'pwq8f_EztkOEsTD0',
    tooltip: 'Searches Amazon offpage keywords',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg6',
    display: ['triggerBusinessRule', 'destinationPostProcessing'],
    childFilters: [
      {
        _id: 'egytftpH5WP85j5h',
        filterLabel: '',
        collection: 'books',
        placeholder: 'Enter keyword',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'keywords',
        controlType: { name: 'dropdown', isRequired: true, isMulti: true, isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Search External Titles',
    parentId: 'wdjq_x3lSJXuWmB8',
    tooltip: 'Toggles if you want to see only partner titles. DEFAULT: FALSE',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg7',
    display: ['triggerBusinessRule', 'destinationPostProcessing'],
    childFilters: [
      {
        _id: 'NhEoH6Iqkg8cuQ4J',
        filterLabel: '',
        comparisonOperator: '$eq',
        type: 'Boolean',
        field: 'partner_title',
        collection: 'books',
        placeholder: 'Boolean',
        controlType: { name: 'toggle' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Ignition',
    parentId: 'TTz7LlmCEMUAR94Z',
    tooltip: 'Checks for Ignition Titles or ORIM-only Titles',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg8',
    display: ['triggerBusinessRule', 'destinationPostProcessing'],
    childFilters: [
      {
        _id: 'ZyZPrjBmKE3h3y-k',
        filterLabel: '',
        comparisonOperator: '$eq',
        type: 'String',
        field: 'marketingservices',
        collection: 'books',
        placeholder: 'Is Ignition Titles',
        controlType: { name: 'dropdown', isMulti: false, isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Product Type',
    parentId: 'Qr7mVdKp3sLxN9Wt',
    tooltip: 'Searches for ebook, audio or print titles. DEFAULT: Ebook only',
    renderNATypes: false,
    isFrequentlyUsed: true,
    shortCode: 'arg108',
    display: ['triggerBusinessRule', 'destinationPostProcessing'],
    childFilters: [
      {
        _id: 'Hn4bTzQe8vRyU2Kd',
        filterLabel: '',
        comparisonOperator: '$in',
        // productType is a scalar String on books, so $in means "is one of".
        type: 'String',
        field: 'productType',
        collection: 'books',
        placeholder: 'Select Product Type(s)',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Public Domain',
    parentId: 'aFPn6iGHsxVF7EZb',
    tooltip: 'Checks for Public Domain or Not Public Domain',
    renderNATypes: false,
    isFrequentlyUsed: true,
    shortCode: 'arg9',
    display: ['triggerBusinessRule', 'destinationPostProcessing'],
    childFilters: [
      {
        _id: 'AqI0q7frKDWZIvbP',
        filterLabel: '',
        comparisonOperator: '$eq',
        type: 'String',
        field: 'publicdomain',
        collection: 'books',
        placeholder: 'Is public domain ?',
        controlType: { name: 'dropdown', isMulti: false, isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Page Count',
    parentId: 'LzKZiuaziFw5PdxE',
    tooltip: 'Find books by page count range',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg10',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: '4Isjt6w8ywkXmS9G',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'page_count',
        collection: 'books',
        placeholder: 'Enter number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Film/TV Adaptation?',
    parentId: 'p1koEc86SvQZwsn2',
    tooltip: 'Indicates if title has been adapted for film or TV',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg11',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'YapVk82-y1S1k1KV',
        filterLabel: '',
        comparisonOperator: '$eq',
        type: 'String',
        field: 'filmtvadaptation',
        collection: 'books',
        placeholder: 'Boolean',
        controlType: { name: 'toggle' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Book Awards',
    parentId: 'lkw9WxHJFwXXx6bQ',
    tooltip: 'Search by Book Awards (Nominated or Winner)',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg12',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'w4fGeO3oC6xsmaBG',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'String',
        field: 'awards.awardname',
        collection: 'books',
        placeholder: 'Select Awards',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Territories',
    parentId: 'UocNaGO5U4jmJGip',
    tooltip: 'Countries where ORIM has the rights to sell a title',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg13',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'QoWPiwY2CR8Oowce',
        filterLabel: '',
        comparisonOperator: '$nin',
        type: 'regex',
        field: 'notforsaleterritory',
        collection: 'books',
        placeholder: 'Select Territories',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Pub Date',
    parentId: 't9XAmhSBYvL2dRCy',
    tooltip:
      'Publication date; for Ignition titles, this is the original publication date and not the Ignition start date.',
    renderNATypes: false,
    isFrequentlyUsed: true,
    shortCode: 'arg14',
    isRelativeChildFilters: true,
    isRelativeToTriggerSchedule: true,
    selectedValueInfo: 'Filter Date Range is from [[startDate]] to [[endDate]]',
    field: 'pubdate-range',
    comparisonOperator: '$or',
    type: 'daterange',
    collection: 'books',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'ttUnTQEW-Ok-N8Cp',
        comparisonOperator: '$or',
        type: 'daterange',
        field: 'relative_days',
        collection: 'books',
        filterLabel: 'Relative Days to Trigger Schedule',
        placeholder: 'Relative Days to Trigger Schedule',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'ttUnTQEW-Ok-pv',
        comparisonOperator: '$or',
        type: 'daterange',
        field: 'consecutive_days',
        collection: 'books',
        filterLabel: 'Consecutive days',
        placeholder: 'Consecutive days',
        controlType: { name: 'inputbox', type: 'number' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  // {
  //   groupBy: 'Title Metadata',
  //   name: 'FrontList',
  //   parentId: 'MzIgx0ix0GxwWpDP',
  //   tooltip: 'Checks for FrontList Title Yes or No',
  //   renderNATypes: false,
  //   isFrequentlyUsed: false,
  //   shortCode: 'arg15',
  //   display: ['triggerBusinessRule'],
  //   childFilters: [
  //     {
  //       _id: '18TU_MJjm-ZuJDbn',
  //       filterLabel: '',
  //       comparisonOperator: '$eq',
  //       type: 'String',
  //       field: 'frontlist',
  //       collection: 'books',
  //       placeholder: 'Is frontlist ?',
  //       controlType: { name: 'dropdown', isMulti: false, isDataStoredInValue: true, isRequired: true },
  //       renderCompOperator: false,
  //       renderStringOperator: false,
  //       isCountryBasedData: false,
  //       isCampaignFilter: false,
  //       isCalculatedField: false,
  //       isPostProcessingFilter: false,
  //       isThemedFilter: false,
  //       isKBDThemedFilter: false,
  //       isCustomCategoryDynamicFilter: false,
  //     },
  //   ],
  // },
  {
    groupBy: 'Title Metadata',
    name: 'OnSale Date',
    parentId: 'WpBNsGhdiR5HMiQ3',
    tooltip: 'Indicates go-live date for both catalog and Ignition titles',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg16',
    isRelativeToTriggerSchedule: true,
    selectedValueInfo: 'Filter Date should be [[operator]] [[startDate]]',
    collection: 'books',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'Fp0rThLChEKuyeOB',
        comparisonOperator: '$lte',
        type: 'Range',
        field: 'onsaledate',
        collection: 'books',
        filterLabel: 'Relative Days to Trigger Schedule',
        placeholder: 'Relative Days to Trigger Schedule',
        controlType: { name: 'inputbox', isRequired: true },
        renderCompOperator: true,
        isRelativeToTriggerSchedule: true,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Series Volume',
    parentId: 'N1JsTY80hQT7oEHZ',
    tooltip: 'If part of a series, indicates which volume of the series',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg17',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'PnAOS5talTDg1wu-',
        filterLabel: '',
        comparisonOperator: '$eq',
        type: 'String',
        field: 'volume',
        collection: 'books',
        placeholder: 'Enter Series Name',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Bundle?',
    parentId: 'ZakCmi9McI4KqWz0',
    tooltip: 'Narrows earch results to bundle',
    renderNATypes: false,
    isFrequentlyUsed: true,
    shortCode: 'arg18',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'YBvS8_3wlXGysNtz',
        filterLabel: '',
        comparisonOperator: '$eq',
        type: 'String',
        field: 'bundle',
        collection: 'books',
        placeholder: 'Boolean',
        controlType: { name: 'dropdown', isMulti: false, isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Editorial Content',
    parentId: 'JFVIC-wZzjcx0f63',
    tooltip:
      'Searches descriptive copy. For multiple keyword searches, enter # between keywords to search for titles with both keywords in the description. To search for titles with at least one of those keywords in the description, separate with a comma.',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg19',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'v1n124iHxod0Y_5o',
        filterLabel: '',
        comparisonOperator: '$regex',
        type: 'regex',
        field: 'description',
        collection: 'books',
        placeholder: 'Fuzzy',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Minimum DLP',
    parentId: 'Nv5OTFt-2GGq5t08',
    tooltip: 'Includes titles that have DLP greater than and equal to provided number.',
    renderNATypes: false,
    isFrequentlyUsed: true,
    shortCode: 'arg20',
    display: ['triggerBusinessRule', 'destinationPostProcessing'],
    childFilters: [
      {
        _id: 'XDBfjxL40dtbv1fC',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'dlp',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Publisher',
    parentId: 'JJNd2oDeB1SRllS4',
    tooltip: 'Search by Publishers',
    renderNATypes: false,
    isFrequentlyUsed: true,
    shortCode: 'arg21',
    display: ['triggerBusinessRule', 'destinationPostProcessing'],
    childFilters: [
      {
        _id: 'TIn5bWWjgCn9GKIf',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'String',
        field: 'publisher',
        collection: 'books',
        placeholder: 'Select',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: true,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Publisher Batch Number',
    parentId: 'b5IYsYrnpoAYLODg',
    tooltip: 'Ignition Batch Number',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg22',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: '59BiTMkCeJQsYOn5',
        filterLabel: '',
        comparisonOperator: '$regex',
        type: 'regex',
        field: 'batch',
        collection: 'bookdata',
        placeholder: 'String',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Custom Categories',
    parentId: 'IAzUC0DrPaHXuV_W',
    tooltip: 'Genre; Based on BISACs mapped to the closest appropriate category',
    renderNATypes: false,
    isFrequentlyUsed: true,
    shortCode: 'arg23',
    display: ['triggerBusinessRule', 'destinationPostProcessing'],
    childFilters: [
      {
        _id: 'MpCgUkIXEXNCIhXD',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'customcategories',
        collection: 'books',
        placeholder: 'Select',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: true,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Bisacs',
    parentId: '8C0tt7SLV1-Zx_2B',
    tooltip: 'Searches against specific Bisacs at 3 levels',
    renderNATypes: false,
    isFrequentlyUsed: true,
    shortCode: 'arg24',
    display: ['triggerBusinessRule', 'destinationPostProcessing'],
    childFilters: [
      {
        _id: 'XCH9Hja6gL9lVgH2',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'bisacs',
        collection: 'books',
        placeholder: 'Select',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: true,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Bisac Name',
    parentId: '48HAvk_PEjedEPla',
    tooltip:
      'Exclude the provided word from the Bisac Field. For multiple keyword searches, enter comma between keywords to exclude the bisacs.',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg25',
    display: ['triggerBusinessRule', 'destinationPostProcessing'],
    childFilters: [
      {
        _id: '8g0sLIy4i67hxCyj',
        filterLabel: '',
        comparisonOperator: 'contains',
        type: 'regex',
        field: 'bisacs',
        collection: 'books',
        placeholder: 'String',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: false,
        renderStringOperator: false,
        renderTextOperator: true,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'FreeVoices?',
    parentId: 'jClpz2FrCB4x6N7R',
    tooltip: 'Indicates if title has been banned ?',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg26',
    display: ['triggerBusinessRule', 'destinationPostProcessing'],
    childFilters: [
      {
        _id: 'ayarmTuCCUaou1s1',
        filterLabel: '',
        comparisonOperator: '$eq',
        type: 'Boolean',
        field: 'freevoice',
        collection: 'books',
        placeholder: 'Boolean',
        controlType: { name: 'toggle' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'KDP UK & AUS?',
    parentId: '6BiREn9m6e9L0bjL',
    tooltip: 'Indicates if title participate in KDP UK & Aus',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg27',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'oO1FVCz9hr8L3i-v',
        filterLabel: '',
        comparisonOperator: '$eq',
        type: 'Boolean',
        field: 'kdpukaus',
        collection: 'books',
        placeholder: 'Boolean',
        controlType: { name: 'toggle' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Bookbub Author Follower Count',
    parentId: 'gWpNZOllWHGrZH0i',
    tooltip: 'Fetch title with bookbub author follower count',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg28',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: '-eiLVPlSDv7NfPIp',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'bookbubFollowerCount',
        collection: 'authorDetails',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: '% of Glance Views',
    parentId: 'uSCbcXL0AoYP1qQc',
    tooltip:
      'The percentage of Amazon glance views for a title in the previous day, relative to the total glance views for the entire ORIM/Ignition catalog on that same day; indicates titles with the highest traffic within a time period',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg29',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'u1WUpgz5EJQMr6EF',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'araTraffic.lastGVPctDaily',
        collection: 'bookdata',
        placeholder: 'Number in %',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    parentId: 'frp00mayjhcgjmh-',
    name: 'Last Glance View Change Prior Day',
    tooltip:
      'The percentage increase or decrease in glance views compared to the prior day; identifies whether a title has received a sudden surge or drop in traffic ',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg30',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'q45AKMmUbp7_iQgf',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'araTraffic.lastGVChangePriorDay',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Last Glance View % Previous Month',
    parentId: 'Rc1Y2pHUYsVsEkwf',
    tooltip:
      'The percentage of Amazon glance views for a title in the previous month, relative to the total glance views for our entire ORIM/Ignition catalog in that same month; indicates titles with the highest traffic within a time period',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg31',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'glcRQSXbwguUpqCi',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'araTraffic.lastGVPctMonthly',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Amazon Star Rating',
    parentId: 's-1ytcTlVLffHpx6',
    tooltip:
      "Average star rating at Amazon. For Range, Please Select 'R' and Specify a Range separated by '-'. For Ex 3-4",
    renderNATypes: true,
    isFrequentlyUsed: true,
    shortCode: 'arg32',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'Ym7QCZT35JWIY2Ka',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'latestRating',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Amazon Review Count',
    parentId: '2609Jn_3gvkZN-bw',
    tooltip: 'Number of Amazon Customer Reviews',
    renderNATypes: true,
    isFrequentlyUsed: true,
    shortCode: 'arg33',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'cC-werY5SEuQr08i',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'latestReviews',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Amazon Rank',
    parentId: 'rzTMZTChctsVrW6k',
    tooltip:
      "Most recently captured Amazon rank. For Range, Please Select 'R' and Specify a Range separated by '-'. For Ex 30000-40000",
    renderNATypes: true,
    isFrequentlyUsed: true,
    shortCode: 'arg34',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'xXv7He9cRN4X0nGN',
        filterLabel: '',
        comparisonOperator: '$lte',
        type: 'Range',
        field: 'rank.currentRank',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Amazon Rank over 3 months',
    parentId: 'F3wdbCCjQgY0hOmd',
    tooltip: 'Average Amazon rank over previous 3 months',
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg35',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'UD0k5LJcog_CvrHe',
        filterLabel: '',
        comparisonOperator: '$lte',
        type: 'number',
        field: 'rank.last90rank',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Amazon consumer price over 3 months',
    parentId: 'ZsXQS6oxD9YoTD2_',
    tooltip: 'Average Amazon consumer price over 3 months',
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg36',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'e8FJIhp83Q2824p4',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'consumerPrice.last90consumerPrice',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        isCountryBasedData: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: '7-Day Average Consumer Price',
    parentId: 'VxJiy3WDlW2r0Yyc',
    tooltip: 'Includes the titles where 7-days Average Consumer Price is greater than provided number',
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg37',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: '7WqiZyJFnjRciA0D',
        filterLabel: '',
        comparisonOperator: '$gt',
        type: 'number',
        field: 'consumerPrice.last7consumerPrice',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: false,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Campaign Performance Data',
    name: 'Prev BB Deals performance by orim proceeds',
    parentId: 'UsIm8gezIy-ZNB9S',
    tooltip: 'Proceeds for last Bookbub deal promotion after removing author share and deal cost',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg39',
    isRelativeChildFilters: true,
    field: '[countries].campaignTypePerformanceData.[campaigntype].orimProceeds',
    isCalculatedField: true,
    collection: 'bookdata',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: '-EeEic6CIS_49rGy',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'campaignTypePerformanceData.orimProceeds',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'fRIUuhHugpLMUrGy',
        field: 'campaigntype',
        controlType: { name: 'dropdown', isDataStoredInValue: true, isRequired: true },
        placeholder: 'Select Campaign Type',
        filterLabel: '',
        comparisonOperator: '',
        type: '',
        collectionName: '',
        isCalculatedField: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: '9IYurvAKErDEgE_X',
    groupBy: 'Campaign Performance Data',
    name: 'Conversion Rate of last run date',
    tooltip: 'Searches conversion rate of last run date',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg40',
    isRelativeChildFilters: true,
    field: '[countries].campaignTypePerformanceData.[campaigntype].lastConversionRate',
    isCalculatedField: true,
    collection: 'bookdata',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'fLX-tBmUp22aPRQb',
        filterLabel: '',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        comparisonOperator: '$gte',
        type: 'number',
        field: 'campaignTypePerformanceData.lastConversionRate',
        collection: 'bookdata',
        placeholder: 'Number',
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'fRIUuhHugpLMUXkP',
        filterLabel: '',
        comparisonOperator: '',
        type: '',
        field: 'campaigntype',
        collectionName: '',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isDataStoredInValue: true, isRequired: true },
        isCalculatedField: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'LrMDjREAYKYsEzSW',
    groupBy: 'Campaign Performance Data',
    name: 'Average Conversion Rate of all run dates',
    tooltip: 'Searches average conversion rate of all run dates',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg41',
    isRelativeChildFilters: true,
    field: '[countries].campaignTypePerformanceData.[campaigntype].avgConversionRate',
    isCalculatedField: true,
    collection: 'bookdata',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'pBneOGJTCfqfMDm1',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'campaignTypePerformanceData.avgConversionRate',
        collection: 'bookdata',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'vRZrd7JMp1lQZ9xX',
        filterLabel: '',
        comparisonOperator: '',
        type: '',
        field: 'campaigntype',
        collectionName: '',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isDataStoredInValue: true, isRequired: true },
        isCalculatedField: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'yUsW0pAzB4PW9PWR',
    groupBy: 'Campaign Performance Data',
    name: 'Last Attributed Units',
    tooltip: 'Searches units sold in last campaign',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg42',
    isRelativeChildFilters: true,
    field: '[countries].campaignTypePerformanceData.[campaigntype].lastAttributedUnits',
    isCalculatedField: true,
    collection: 'bookdata',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'uxmkSp78k4Agtsx6',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'campaignTypePerformanceData.lastAttributedUnits',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'td5UvoQSurrG42sO',
        filterLabel: '',
        comparisonOperator: '',
        type: '',
        field: 'campaigntype',
        collectionName: '',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isDataStoredInValue: true, isRequired: true },
        isCalculatedField: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'jG386ZOrWz_zOGay',
    groupBy: 'Campaign Performance Data',
    name: 'Average Attributed Units',
    tooltip: 'Searches average units sold for all run dates',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg43',
    isRelativeChildFilters: true,
    field: '[countries].campaignTypePerformanceData.[campaigntype].avgAttributedUnits',
    isCalculatedField: true,
    collection: 'bookdata',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'Nknx0cz908ZTUN1Z',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'campaignTypePerformanceData.avgAttributedUnits',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'S1CddicYRazHAl9Z',
        filterLabel: '',
        comparisonOperator: '',
        type: '',
        field: 'campaigntype',
        collectionName: '',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isDataStoredInValue: true, isRequired: true },
        isCalculatedField: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'y2hX3_ApCUrq6Lb1',
    groupBy: 'Campaign Performance Data',
    name: 'Clicks for last run date',
    tooltip: 'Searches for amount of clicks for the last run date',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg44',
    isRelativeChildFilters: true,
    field: '[countries].campaignTypePerformanceData.[campaigntype].lastClicks',
    isCalculatedField: true,
    collection: 'bookdata',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'N5zbELImwp_ZN1aN',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'campaignTypePerformanceData.lastClicks',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'WXRMDgeeEPuZu3eX',
        filterLabel: '',
        comparisonOperator: '',
        type: '',
        field: 'campaigntype',
        collectionName: '',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isDataStoredInValue: true, isRequired: true },
        isCalculatedField: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'KwD6SQLtb4Fhx5qz',
    groupBy: 'Campaign Performance Data',
    name: 'Average Clicks for all run dates',
    tooltip: 'Checks for average clicks for all run dates',
    isRelativeChildFilters: true,
    field: '[countries].campaignTypePerformanceData.[campaigntype].avgClicks',
    isCalculatedField: true,
    collection: 'bookdata',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg45',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'Wz1lzb23wxxQBhLu',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'campaignTypePerformanceData.avgClicks',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'IMtI-GzNJj7bwoXG',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'campaigntype',
        collectionName: 'campaigntypes',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isDataStoredInValue: true, isRequired: true },
        isCalculatedField: true,
        isCampaignExclusionFilter: true, //TODO:
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'uFwKawvO6mBgFYTd',
    groupBy: 'Sales Data',
    name: 'Amazon lending proceeds over prev 30 days',
    tooltip: 'Amazon lending proceeds over prev 30 days',
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg46',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'OdIsLtgnwfK0n9xh',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'salesByRetailer.Amazon.last30LendingProceeds',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'E7DGd94FDgWhBgnG',
    groupBy: 'Sales Data',
    name: 'Amazon average monthly lending sales for the last 3 months',
    tooltip: 'Amazon average monthly lending sales for the last 3 months',
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg47',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'wzMtvMqsr3Npmgy0',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'salesByRetailer.Amazon.last90AvgMonthlyLendingProceeds',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'qjhWSLKsff1z6W2N',
    groupBy: 'Sales Data',
    name: 'Ordered units increase over prior period',
    tooltip: 'Change in Amazon ordered units over the previous day',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg48',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'Q7BfgDgjF4rJFvS8',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'salesByRetailer.Amazon.changeUnitsPriorDay',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'NQWcaZ4IBLQs9TIW',
    groupBy: 'Sales Data',
    name: 'Amazon Proceeds over prev 30 days',
    tooltip:
      'Amazon proceeds over previous 30 days. For Range, Please Select "R" and Specify a Range separated by "to". For Ex 3to4',
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg49',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'xuGOmyLiCJg2nQCB',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'salesByRetailer.Amazon.last30Proceeds',
        collection: 'bookdata',
        placeholder: 'Value',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'Rg1JCDfg7PAPkxxQ',
    groupBy: 'Sales Data',
    name: '30-day unit sales [Amazon]',
    tooltip:
      'Includes the titles where previous 30-days unit sales for Amazon. For Range, Please Select "R" and Specify a Range separated by "to". For Ex 3to4',
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg50',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'G2pnc4nfKRZYiP9P',
        filterLabel: '',
        comparisonOperator: '$lt',
        type: 'Range',
        field: 'salesByRetailer.Amazon.last30Units',
        collection: 'bookdata',
        placeholder: 'Value',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'pciKk27S_DVvcxBg',
    groupBy: 'Sales Data',
    name: '30-day unit sales',
    tooltip: 'Includes the titles where previous 30-days unit sales of all retailers is less than provided number',
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg51',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'qRcMZw-BPxy1A76l',
        filterLabel: '',
        comparisonOperator: '$lt',
        type: 'number',
        field: 'sales.last30Units',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'yXYFU5cpDZnLo1eU',
    groupBy: 'Sales Data',
    name: '7-day unit sales',
    tooltip: 'Includes the titles where previous 7-days unit sales of all retailers is greater than provided number',
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg52',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'iBV-cJHHbe9JpzUR',
        filterLabel: '',
        comparisonOperator: '$gt',
        type: 'number',
        field: 'sales.last7Units',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'S-h9ahSHCHxrGQNN',
    groupBy: 'Sales Data',
    name: '30-Day Average Amazon Consumer Price',
    tooltip: 'Includes the titles where 30-days Average Amazon Consumer Price is greater than provided number',
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg53',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'yAMSVWiSwoI7ntcx',
        filterLabel: '',
        comparisonOperator: '$gt',
        type: 'number',
        field: 'consumerPrice.last30consumerPrice',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'W-4MyymahFH9JT-i',
    groupBy: 'Sales Data',
    name: 'Apple Proceeds over prev 30 days',
    tooltip: 'Apple proceeds over previous 30 days',
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg54',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'NmO2TNgMCNHRNP0W',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'salesByRetailer.Apple.last30Proceeds',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: '9LncV7ytl9L9iN2O',
    groupBy: 'Sales Data',
    name: '30-day unit sales [Apple]',
    tooltip: 'Includes the titles where previous 30-days unit sales for Apple',
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg55',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'MDrPr4B28GDTdDx1',
        filterLabel: '',
        comparisonOperator: '$lt',
        type: 'number',
        field: 'salesByRetailer.Apple.last30Units',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  // {
  //   parentId: 'udbfTPq1Lixbo9T9',
  //   groupBy: 'Global Campaign Processing',
  //   name: 'Restrict Author Count',
  //   tooltip: 'Maximum books by individual authors in result',
  //   renderNATypes: false,
  //   isFrequentlyUsed: false,
  //   childFilters: [
  //     {
  //       _id: 'hnpRkgy40psFOBV4',
  //       filterLabel: '',
  //       comparisonOperator: '$eq',
  //       type: 'number',
  //       field: 'restrictAuthorCount',
  //       collection: 'generic',
  //       controlType: { name: 'inputbox', isRequired: true },
  //       renderCompOperator: true,
  //       renderStringOperator: false,
  //       isCountryBasedData: false,
  //       isCampaignFilter: false,
  //       isCalculatedField: false,
  //       isPostProcessingFilter: true,
  //       isThemedFilter: false,
  //       isKBDThemedFilter: false,
  //       isCustomCategoryDynamicFilter: false,
  //     },
  //   ],
  // },
  // {
  //   parentId: 'UgDqknl8SUvec-k_',
  //   groupBy: 'Global Campaign Processing',
  //   name: 'Restrict Title Count',
  //   tooltip: 'Number of titles that will be displayed in final results',
  //   renderNATypes: false,
  //   isFrequentlyUsed: false,
  //   childFilters: [
  //     {
  //       _id: 'Ffnp0xPOXj031W5V',
  //       filterLabel: '',
  //       comparisonOperator: '$eq',
  //       type: 'number',
  //       field: 'restrictTitleCount',
  //       collection: 'generic',
  //       controlType: { name: 'inputbox', isRequired: true },
  //       renderCompOperator: false,
  //       renderStringOperator: false,
  //       isCountryBasedData: false,
  //       isCampaignFilter: false,
  //       isCalculatedField: false,
  //       isPostProcessingFilter: true,
  //       isThemedFilter: false,
  //       isKBDThemedFilter: false,
  //       isCustomCategoryDynamicFilter: false,
  //     },
  //   ],
  // },
  {
    parentId: 'X0tt8dZoAI52O3a_',
    groupBy: 'Global Campaign Processing',
    name: 'Milestone Date',
    tooltip: 'Indicates go-live date for Event',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg56',
    isRelativeChildFilters: true,
    isRelativeToTriggerSchedule: true,
    selectedValueInfo: 'Filter Date Range is from [[startDate]] to [[endDate]]',
    collection: 'MilestoneEvents',
    field: 'daterange-simple',
    comparisonOperator: '$or',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'wTT5kgvc_1Um5fWfabc',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'relative_days',
        collection: 'MilestoneEvents',
        filterLabel: 'Relative Days to Trigger Schedule',
        placeholder: 'Relative Days to Trigger Schedule',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'wTT5kgvc_1Um5fWf',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'consecutive_days',
        collection: 'MilestoneEvents',
        filterLabel: 'Consecutive days',
        placeholder: 'Consecutive days',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: '-FBdJBpWrEYS5lcx',
    groupBy: 'Campaign Run Dates',
    name: 'Find titles that are included in specific campaigns relative to trigger date',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg57',
    isRelativeToTriggerSchedule: true,
    selectedValueInfo: 'Filter Date Range is from [[startDate]] to [[endDate]]',
    isRelativeChildFilters: true,
    isCampaignFilter: true,
    field: 'daterange-limited',
    type: 'daterange',
    comparisonOperator: '$or',
    collection: 'campaigngrid',
    display: ['triggerBusinessRule'],
    tooltip: 'If the consecutive days field is left blank, the query will include campaigns with no end date.',
    childFilters: [
      {
        _id: 'Mg07xOBN6zREb-YE',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'relative_days',
        collection: 'campaigngrid',
        filterLabel: 'Relative Days to Trigger Schedule',
        placeholder: 'Relative Days to Trigger Schedule',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
        isRelativeToTriggerSchedule: true,
      },
      {
        _id: 'wgmlJOh4oTCqOzHh',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'consecutive_days',
        collection: 'campaigngrid',
        filterLabel: 'Consecutive days',
        placeholder: 'Consecutive days',
        showEndDateOptionalFilter: true,
        controlType: { name: 'inputbox' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
        isRelativeToTriggerSchedule: true,
      },
      {
        _id: 'XSdH2Cm4fspvwsID',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'regex',
        field: 'promotedtitles.countries',
        collection: 'campaigngrid',
        placeholder: 'Select Territories',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'agJMgT9S-ftlY_0ea',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'campaigntype',
        collection: 'campaigntypes',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isBlockListExclusionFilter: true,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: '3buQG6LZGauUoAFy',
    groupBy: 'Campaign Run Dates',
    name: 'Find titles that are not included in specific campaigns relative to trigger date',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg58',
    display: ['triggerBusinessRule'],
    isRelativeToTriggerSchedule: true,
    selectedValueInfo: 'Filter Date Range is from [[startDate]] to [[endDate]]',
    tooltip: 'If the consecutive days field is left blank, the query will include campaigns with no end date.',
    childFilters: [
      {
        _id: 'YkUyTRjk9Kalibae',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'relative_days',
        collection: 'campaigngrid',
        filterLabel: 'Relative Days to Trigger Schedule',
        placeholder: 'Relative Days to Trigger Schedule',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        isRelativeToTriggerSchedule: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isSameCampaignExclusionFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'YbIbF7fOiSMs1YiX',
        collection: 'campaigngrid',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'consecutive_days',
        filterLabel: 'Consecutive days',
        placeholder: 'Consecutive days',
        controlType: { name: 'inputbox', type: 'number' },
        isRelativeToTriggerSchedule: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isSameCampaignExclusionFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'bYSsT0eu3kVs5_8_',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'array',
        field: 'promotedtitles.countries',
        collection: 'campaigngrid',
        placeholder: 'Select Territories',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isSameCampaignExclusionFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'agJMgT9S-ftlY_0f',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'campaigntype',
        collection: 'campaigntypes',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: true,
        isSameCampaignExclusionFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isBlockListExclusionFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'mA6tG78CuLIxgDbe',
    groupBy: 'Exclusion Filters',
    name: 'Exclude books that are already scheduled',
    renderNATypes: false,
    isFrequentlyUsed: false,
    isRelativeToTriggerSchedule: true,
    display: ['triggerBusinessRule'],
    selectedValueInfo: 'Filter Date Range is from [[startDate]] to [[endDate]]',
    tooltip: 'If the consecutive days field is left blank, the query will include campaigns with no end date.',
    shortCode: 'arg59',
    childFilters: [
      {
        _id: 'UzD8Eh9pz_N3q35J',
        collectionName: 'excludebookincampaigntypeanddatarange',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'relative_days',
        filterLabel: 'Relative Days to Trigger Schedule',
        placeholder: 'Relative Days to Trigger Schedule',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        isRelativeToTriggerSchedule: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'kTQ9AEZ8EbNOqKyD',
        collectionName: 'excludebookincampaigntypeanddatarange',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'consecutive_days',
        filterLabel: 'Consecutive days',
        placeholder: 'Consecutive days',
        controlType: { name: 'inputbox', type: 'number' },
        isRelativeToTriggerSchedule: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: '42zs_Igsl5OQ53qB',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'campaigntype',
        collectionName: 'excludebookincampaigntypeanddatarange',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: '8nSaF_bI3pMXNGUB',
    groupBy: 'Exclusion Filters',
    name: 'Exclude Blocklist Titles For Date Range',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg60',
    isRelativeToTriggerSchedule: true,
    display: ['triggerBusinessRule'],
    selectedValueInfo: 'Filter Date Range is from [[startDate]] to [[endDate]]',
    childFilters: [
      {
        _id: '3HxN2aFFEMo6N_y6',
        collection: 'blocktitlelists',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'relative_days',
        filterLabel: 'Relative Days to Trigger Schedule',
        placeholder: 'Relative Days to Trigger Schedule',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        isRelativeToTriggerSchedule: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isBlockListExclusionFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'ILaGkLm2QkkeLumt',
        collection: 'blocktitlelists',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'consecutive_days',
        filterLabel: 'Consecutive days',
        placeholder: 'Consecutive days',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        isRelativeToTriggerSchedule: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isBlockListExclusionFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'iorfRloqO009TePq',
    groupBy: 'Exclusion Filters',
    name: 'Exclude books of same series that are already scheduled in the Date Range?',
    renderNATypes: false,
    isFrequentlyUsed: false,
    isRelativeToTriggerSchedule: true,
    selectedValueInfo: 'Filter Date Range is from [[startDate]] to [[endDate]]',
    shortCode: 'arg61',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'wpI3vrtjDJrQ66fX',
        collectionName: 'SeriesExclusion',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'relative_days',
        filterLabel: 'Relative Days to Trigger Schedule',
        placeholder: 'Relative Days to Trigger Schedule',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        isRelativeToTriggerSchedule: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'wjGG5eyShvqnVnnH',
        collectionName: 'SeriesExclusion',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'consecutive_days',
        filterLabel: 'Consecutive days',
        placeholder: 'Consecutive days',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        isRelativeToTriggerSchedule: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'agJMgT9S-ftlY_0e',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'campaigntype',
        collection: 'campaigntypes',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isBlockListExclusionFilter: true,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'hvkvezxGFBzh-ImN',
    groupBy: 'Ignition & Publisher Support',
    name: 'Ignition Support',
    tooltip: 'Search title by ignition priority',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg62',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'RxTEmxtfVhl6talf',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'String',
        field: 'ignitionBatchUplift.priority',
        collection: 'bookdata',
        placeholder: 'Select Priority',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'dybiVLxYb8HZs6PU',
    groupBy: 'Ignition & Publisher Support',
    name: 'Prorated Title Level Monthly Uplift',
    tooltip:
      "View Prorated Title Level Monthly Uplift. For Range, Please Select 'R' and Specify a Range separated by '-'. For Ex 3-4",
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg63',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'pMRtvE8dThqGQ1B5',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'ignitionBatchUplift.titleLevelMonthlyProratedUplift',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'wGTWH54maFPF8beC',
    groupBy: 'Ignition & Publisher Support',
    name: 'Monthly Title Level Baseline',
    tooltip:
      "View Monthly Title Level Baseline. For Range, Please Select 'R' and Specify a Range separated by '-'. For Ex 3-4",
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg64',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'pgjhPH454evgKYxq',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'ignitionBatchUplift.titleLevelMonthlyBaseline',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'JEn3Ge6Degalbybw',
    groupBy: 'Ignition & Publisher Support',
    name: 'Cut Rate',
    tooltip: "View Orim Cut Rate. For Range, Please Select 'R' and Specify a Range separated by '-'. For Ex 3-4",
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg65',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'E1UryhvTXhshCONd',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'ignitionOrimCutRate',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'Gi_eADJLPQpTqpPU',
    groupBy: 'Predictive Analysis',
    name: 'Predicted Highest Average Units',
    tooltip: 'Similar titles predicted highest average unit',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg66',
    isRelativeChildFilters: true,
    field: 'similarity.predictivePerformanceData.[countries].[campaigntype].highestUnit',
    isCalculatedField: true,
    collection: 'bookdata',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'd9ESPPRrJi3XUMrO',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'similarity.highestUnit',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'agJMgT9S-abhasd',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'campaigntype',
        collection: 'campaigntypes',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isCalculatedField: true,
        isPostProcessingFilter: false,
        isBlockListExclusionFilter: true,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: '7rJPcgZUia-TRRL7',
    groupBy: 'Predictive Analysis',
    name: 'Predicted Median Units',
    tooltip: 'Similar titles predicted median unit',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg67',
    isRelativeChildFilters: true,
    field: 'similarity.predictivePerformanceData.[countries].[campaigntype].medianUnit',
    isCalculatedField: true,
    collection: 'bookdata',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'NSViwoq6VjOdpUcH',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'similarity.predictivePerformanceData.medianUnit',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'agJMgT9S-abha',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'campaigntype',
        collection: 'campaigntypes',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isCalculatedField: true,
        isPostProcessingFilter: false,
        isBlockListExclusionFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: '-FBdJBpWrEYS5Bpw',
    groupBy: 'Campaign Run Dates',
    name: 'Find titles that are included in specific campaigns relative to another campaign',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg68',
    isRelativeToTriggerSchedule: true,
    selectedValueInfo:
      'Find common titles which is running in [[campaigntype]] on [[startDate]] and also running in [[campaigntype2]] on [[relativeToCampaignStartDate]]',
    isRelativeChildFilters: true,
    isRelativeToCampaign: true,
    field: 'daterange-limited',
    type: 'daterange',
    comparisonOperator: '$or',
    collection: 'campaigngrid',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'Mg07xOBN6zREb-YE',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'relative_days',
        collection: 'campaigngrid',
        filterLabel: 'Relative Days to Trigger Schedule',
        placeholder: 'Relative Days to Trigger Schedule',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
        isRelativeToTriggerSchedule: true,
      },
      {
        _id: 'wgmlJOh4oTCqOzHh',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'relative_to_campaign',
        collection: 'campaigngrid',
        filterLabel: 'Relaive Days to campaign date',
        placeholder: 'Consecutive days',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: true,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
        isRelativeToTriggerSchedule: true,
      },
      {
        _id: 'agJMgT9S-ftlY_agJ',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'campaigntype',
        collection: 'campaigntypes',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isBlockListExclusionFilter: true,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'agJMgT9S-ftlY_0ea',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'campaigntype',
        collection: 'campaigntypes',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isBlockListExclusionFilter: true,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Author Title Limit',
    parentId: 'Nv5OTFt-2GGq3a63',
    field: 'authorTitleLimit',
    tooltip: 'Include titles per author',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg69',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'XDBfjxL40dtbv1ab',
        filterLabel: '',
        comparisonOperator: '',
        type: 'number',
        field: '',
        collection: '',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: true,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Amazon GV Last 30 days',
    parentId: 'Nv5OTFt-2GGq35s7',
    tooltip: 'Amazon glance views for a title in the last 30 days',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg70',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'XDBfjxL40dtbvrqw',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'araTraffic.last30GVDaily',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Amazon GV Last 90 days',
    parentId: 'Nv5OTFt-2rsq35s7',
    tooltip: 'Amazon glance views for a title in the last 90 days',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg71',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'XDBfjxG30dtbvrqw',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'araTraffic.last90GVDaily',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Amazon Review Quote Source',
    parentId: 'Nv5OTst-2rsq35s7',
    tooltip: 'Amazon editorial review quote source',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg72',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'XDBfjxs30dtbvrqw',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'amazonEditorialReview.source',
        collection: 'bookdata',
        placeholder: 'Select',
        controlType: {
          name: 'dropdown',
          isMulti: true,
          isDataStoredInValue: true,
        },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Amazon Review Quote Keyword',
    parentId: 'Nv52TFt-2rsq35s7',
    tooltip: 'Amazon editorial review quote keyword',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg73',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'XDBfjxG50dtbvrqw',
        comparisonOperator: '$regex',
        type: 'regex',
        field: 'amazonEditorialReview.review',
        collection: 'bookdata',
        filterLabel: '',
        placeholder: 'String',
        tooltip: 'Searches for amazon editorial review quote based on input',
        controlType: {
          name: 'inputbox',
          type: 'number',
        },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'E7DGd94wsgWhBgnG',
    groupBy: 'Sales Data',
    name: '90-day unit sales [Amazon]',
    tooltip: 'Includes the titles where previous 90-days unit sales for Amazon',
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg74',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'wzMtvstzza3Npmgy0',
        filterLabel: '',
        comparisonOperator: '$lt',
        type: 'number',
        field: 'salesByRetailer.Amazon.last90Units',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'E7DGHd94wsgWhBgnG',
    groupBy: 'Sales Data',
    name: 'Amazon Proceeds over prev 90 days',
    tooltip:
      'Amazon proceeds over previous 90 days. For Range, Please Select "R" and Specify a Range separated by "to". For Ex 3to4',
    renderNATypes: true,
    isFrequentlyUsed: false,
    shortCode: 'arg75',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'wzMtvMzza3Npmgy0',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'salesByRetailer.Amazon.last90Proceeds',
        collection: 'bookdata',
        placeholder: 'Value',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        isCountryBasedData: true,
        renderStringOperator: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Last 90 isKU',
    parentId: 'VxJiy3WDlW2r0Ayd',
    tooltip: 'consumerPriceOptimizationByRetailer => Amazon => last90Days => isKU',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg76',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'VxJiy3WDlW2r0Yyn',
        filterLabel: '',
        comparisonOperator: '$eq',
        type: 'Boolean',
        field: 'consumerPriceOptimizationByRetailer.Amazon.last90Days.isKU',
        collection: 'bookdata',
        placeholder: 'Boolean',
        controlType: {
          name: 'dropdown',
          isMulti: false,
          isDataStoredInValue: true,
          checkBoolean: true,
        },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Last 90 Most Recent Full Price',
    tooltip: 'consumerPriceOptimizationByRetailer => Amazon => last90Days => mostRecentFullPrice',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'VxJiy3WDlW2r0Aye',
    shortCode: 'arg77',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'VxJiy3WDlW2r0Yym',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'consumerPriceOptimizationByRetailer.Amazon.last90Days.mostRecentFullPrice',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: {
          name: 'inputbox',
          type: 'number',
        },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Last 90 Title-Level Total GVs (Full Price) >= Median GVs',
    tooltip: 'Is Title Last 90 Title-Level Total GVs (Full Price) >= Median GVs',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'VxJiy3WDlW2r0YAf',
    shortCode: 'arg78',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'VxJiy3WDlW2r0Yyo',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'expression',
        field:
          'consumerPriceOptimizationByRetailer.Amazon.last90Days.titleLevelTotalGVsAtFullPrice&&consumerPriceOptimizationByRetailer.Amazon.last90Days.medianGVs',
        collection: 'bookdata',
        placeholder: 'Boolean',
        controlType: {
          name: 'dropdown',
          isMulti: false,
          isDataStoredInValue: true,
        },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Last 90 Title-Level Total GVs >= First Quartile GVs',
    tooltip: 'Is Title Last 90 Title-Level Total GVs >= First Quartile GVs',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'VxJiy3WDlW2r1Yyg',
    shortCode: 'arg79',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'VxJiy3WDlW2r0Yyp',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'expression',
        field:
          'consumerPriceOptimizationByRetailer.Amazon.last90Days.titleLevelTotalGVs&&consumerPriceOptimizationByRetailer.Amazon.last90Days.firstQuartileGVs',
        collection: 'bookdata',
        placeholder: 'Boolean',
        controlType: {
          name: 'dropdown',
          isMulti: false,
          isDataStoredInValue: true,
        },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Last 90 Title CVR – Average CVR at Price',
    tooltip: 'consumerPriceOptimizationByRetailer => Amazon => last90Days => titleCVR_averageConversionRateAtPrice',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'VxJiy3WDlW2i0Yyh',
    shortCode: 'arg80',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'VxJiy3WDlW2r0Yyq',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'consumerPriceOptimizationByRetailer.Amazon.last90Days.titleCVR_averageConversionRateAtPrice',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: {
          name: 'inputbox',
          type: 'number',
        },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Last 180 isKU',
    tooltip: 'consumerPriceOptimizationByRetailer => Amazon => last180Days => isKU',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'VxJiy3WDlA2r0Yyi',
    shortCode: 'arg81',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'VxJiy3WDlW2r0Yyr',
        filterLabel: '',
        comparisonOperator: '$eq',
        type: 'Boolean',
        field: 'consumerPriceOptimizationByRetailer.Amazon.last180Days.isKU',
        collection: 'bookdata',
        placeholder: 'Boolean',
        controlType: {
          name: 'dropdown',
          isMulti: false,
          isDataStoredInValue: true,
          checkBoolean: true,
        },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Last 180 Most Recent Full Price',
    tooltip: 'consumerPriceOptimizationByRetailer => Amazon => last180Days => mostRecentFullPrice',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'VxJiy3WDsW2r0Yyj',
    shortCode: 'arg82',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'VxJiy3WDlW2r0Yys',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'consumerPriceOptimizationByRetailer.Amazon.last180Days.mostRecentFullPrice',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: {
          name: 'inputbox',
          type: 'number',
        },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Last 180 Title-Level Total GVs (Full Price) >= Median GVs',
    tooltip: 'Is Title Last 180 Title-Level Total GVs (Full Price) >= Median GVs',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'VxJiy3WDlW2r8Yyk',
    shortCode: 'arg83',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'VxJiy3WDlW2r0Yyt',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'expression',
        field:
          'consumerPriceOptimizationByRetailer.Amazon.last180Days.titleLevelTotalGVsAtFullPrice&&consumerPriceOptimizationByRetailer.Amazon.last180Days.medianGVs',
        collection: 'bookdata',
        placeholder: 'Boolean',
        controlType: {
          name: 'dropdown',
          isMulti: false,
          isDataStoredInValue: true,
        },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Last 180 Title-Level Total GVs >= First Quartile GVs',
    tooltip: 'Is Title Last 180 Title-Level Total GVs >= First Quartile GVs',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'VxJiy3WDlW2r2Yyl',
    shortCode: 'arg84',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'VxJiy3WDlW2r0Yyu',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'expression',
        field:
          'consumerPriceOptimizationByRetailer.Amazon.last180Days.titleLevelTotalGVs&&consumerPriceOptimizationByRetailer.Amazon.last180Days.firstQuartileGVs',
        collection: 'bookdata',
        placeholder: 'Boolean',
        controlType: {
          name: 'dropdown',
          isMulti: false,
          isDataStoredInValue: true,
        },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'Last 180 Title CVR – Average CVR at Price',
    tooltip: 'consumerPriceOptimizationByRetailer => Amazon => last180Days => titleCVR_averageConversionRateAtPrice',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'VxJiy3WDlG2r0Aha',
    shortCode: 'arg85',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'VxJiy3WDlW2r0Yyv',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'number',
        field: 'consumerPriceOptimizationByRetailer.Amazon.last180Days.titleCVR_averageConversionRateAtPrice',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: {
          name: 'inputbox',
          type: 'number',
        },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'UasdtG78CuLIxuen',
    groupBy: 'External Submission',
    name: 'External Submission',
    renderNATypes: false,
    isFrequentlyUsed: false,
    isRelativeToTriggerSchedule: true,
    isRelativeChildFilters: true,
    selectedValueInfo: 'Filter Date Range is from [[startDate]] to [[endDate]]',
    tooltip: 'titles that are included in external submissions for a specific campaign type and date range.',
    shortCode: 'arg86',
    field: 'daterange-limited',
    type: 'daterange',
    comparisonOperator: '$or',
    collection: 'submission',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'alkjEh9pz_N3q4kn',
        collectionName: 'submission',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'relative_days',
        filterLabel: 'Relative Days to Trigger Schedule',
        placeholder: 'Relative Days to Trigger Schedule',
        controlType: { name: 'inputbox', isRequired: true, type: 'number' },
        isRelativeToTriggerSchedule: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'usf8AEZ8EbNOJhg1',
        collectionName: 'submission',
        comparisonOperator: '$regex',
        type: 'number',
        field: 'consecutive_days',
        filterLabel: 'Consecutive days',
        placeholder: 'Consecutive days',
        controlType: { name: 'inputbox', type: 'number' },
        isRelativeToTriggerSchedule: true,
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'ujSsT0eu3kVs598m',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'array',
        field: 'promotedtitles.countries',
        collection: 'submission',
        placeholder: 'Select Territories',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isSameCampaignExclusionFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'msd7_Igsl5OQKBA8',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'campaigntype',
        collectionName: 'submission',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Sales Data',
    name: 'Average Amazon Sales per Unit Last 30 days',
    tooltip:
      'The average Amazon sales per unit would be calculated by dividing last 30 proceeds by last 30 units. For Range, Please Select "R" and Specify a Range separated by "to". For Ex 3to4',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'jnJiy3WDlW2r27hb',
    shortCode: 'arg87',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'Hyaiy3WDlW2r07Hn',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'divideAndCheck',
        field: 'salesByRetailer.Amazon.last30Proceeds&&salesByRetailer.Amazon.last30Units',
        collection: 'bookdata',
        placeholder: 'value',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Amazon Site Data',
    name: 'DLP = Last 90 Most Recent Full Price',
    tooltip: 'Is Last 90 Most Recent Full Price is equal to DLP',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'VxJiy3WDlW2r8Yyk',
    shortCode: 'arg88',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'VxJiy3WDlW2r0Yyt',
        filterLabel: '',
        comparisonOperator: '$eq',
        type: 'expression',
        field: 'consumerPriceOptimizationByRetailer.Amazon.last90Days.mostRecentFullPrice&&dlp',
        collection: 'bookdata',
        placeholder: 'Boolean',
        controlType: {
          name: 'dropdown',
          isMulti: false,
          isDataStoredInValue: true,
        },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Campaign Performance Data',
    name: '7-day content click',
    tooltip: '7-day content click',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'hniy3W7stW2r8mtf',
    shortCode: 'arg89',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'jy6G4CgbRf6Kamns',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'sitePerformanceMetrics.aggregate7DaysContentClick',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Campaign Performance Data',
    name: '30-day content clicks',
    tooltip: '30-day content clicks',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'sQt2rstW2ry3W7a',
    shortCode: 'arg90',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'uTvGstW7Ky3W1s',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'sitePerformanceMetrics.aggregate30DaysContentClick',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Campaign Performance Data',
    name: '7-day attributed content revenue',
    tooltip: '7-day attributed content revenue',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'kyc4ha8s61bask67d',
    shortCode: 'arg91',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'iev71msS1bask67d',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'sitePerformanceMetrics.aggregate7DaysAttributedContentRevenue',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Campaign Performance Data',
    name: '30-day attributed content revenue',
    tooltip: '30-day attributed content revenue',
    renderNATypes: false,
    isFrequentlyUsed: false,
    parentId: 'yqbs7aAmdajL8d',
    shortCode: 'arg92',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'jHaJbd678AJndan',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'sitePerformanceMetrics.aggregate30DaysAttributedContentRevenue',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: true,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'dybiVLey7aZs6An',
    groupBy: 'Ignition & Publisher Support',
    name: 'Prorated Monthly Uplift %',
    tooltip: 'Prorated Uplift/Prorated Baseline',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg93',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'pMRtvEa12dhqGQ1dq',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'ignitionBatchUplift.titleLevelMonthlyProratedUpliftPct',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'dybiikass6Nh',
    groupBy: 'Ignition & Publisher Support',
    name: 'Estimated Monthly Uplift %',
    tooltip: '(Estimated Campaign Revenue + Prorated Title Full-Month Uplift)/titleLevelBaseline * 100',
    isFrequentlyUsed: false,
    shortCode: 'arg94',
    display: ['triggerBusinessRule'],
    isRelativeChildFilters: true,
    isCalculatedField: true,
    field: 'US.campaignTypePerformanceData.[campaigntype].estimatedMonthlyUpliftPct',
    collection: 'bookdata',
    childFilters: [
      {
        _id: 'pMRtvEueyAgGQ1dq',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'campaignTypePerformanceData.estimatedMonthlyUpliftPct',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'agJMgT9asbatlY_0ea',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'campaigntype',
        collection: 'campaigntypes',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isCalculatedField: true,
        isPostProcessingFilter: false,
        isBlockListExclusionFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'dybiValsuasd6An',
    groupBy: 'Ignition & Publisher Support',
    name: 'Units away from 50% Uplift',
    tooltip: '(titleLevelMonthlyBaseline*0.5/predicted median unit)/0.7',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg95',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'pMRtvEaau7aQ1dq',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'ignitionBatchUplift.unitsAwayFrom50PctUplift',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'dybiJhba7aNh',
    groupBy: 'Ignition & Publisher Support',
    name: 'Diff in Estimated Monthly Uplift % and Prorated Monthly Uplift %',
    tooltip: 'Estimated Monthly Uplift % - Prorated Monthly Uplift %',
    isFrequentlyUsed: false,
    shortCode: 'arg96',
    display: ['triggerBusinessRule'],
    isRelativeChildFilters: true,
    isCalculatedField: true,
    field: 'US.campaignTypePerformanceData.[campaigntype].diffInEstimatedMonthlyUpliftPctAndProratedMonthlyUpliftPct',
    collection: 'bookdata',
    childFilters: [
      {
        _id: 'pMRtvUyaQhGQ1dq',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'campaignTypePerformanceData.diffInEstimatedMonthlyUpliftPctAndProratedMonthlyUpliftPct',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'agJMgT9asYgas0ea',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'campaigntype',
        collection: 'campaigntypes',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isCalculatedField: true,
        isPostProcessingFilter: false,
        isBlockListExclusionFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'dybiJhlksaNh',
    groupBy: 'Amazon Site Data',
    name: 'Potential Label',
    tooltip: 'Select one or more Amazon Top Reviews Configurations',
    isFrequentlyUsed: false,
    renderNATypes: false,
    shortCode: 'arg97',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'agJMgT9asYgasadf',
        filterLabel: '',
        collection: 'amazoneligibilityconfigurations',
        placeholder: 'Select Configuration(s)',
        comparisonOperator: '$in',
        type: 'String',
        field: 'amazonTopReviewsConfiguration',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Synchronizer',
    name: 'Historical Timeframe',
    parentId: 'Na8OTstha2rsq35s7',
    tooltip:
      'Lookback window used by the model. MTD = current month-to-date. Historical options come from the active Synchronizer timeframe endpoint.',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg98',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'XDBfjxs30dtbvrqw',
        filterLabel: '',
        comparisonOperator: '$eq',
        type: 'String',
        field: 'timeframe',
        collection: 'synchronizer_results',
        placeholder: 'Select',
        controlType: {
          name: 'dropdown',
          isDataStoredInValue: true,
        },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'kvkvjbxGFazhImN',
    groupBy: 'Synchronizer',
    name: 'Promo Recommendation',
    tooltip: 'Promotion recommendation for the next-month decision.',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg99',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'KxTaxkaVhljtalf',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'promoRecoOrganic',
        collection: 'synchronizer_results',
        placeholder: 'Select Promotion Label',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'hAdkT8Vgyncx9pQ',
    groupBy: 'Synchronizer',
    name: 'Prediction Confidence',
    tooltip:
      'Confidence/review signal from the Synchronizer model. Low means the row should be reviewed before action.',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg106',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'Q7mFz8xpc91NsLv',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'predictionConfidence',
        collection: 'synchronizer_results',
        placeholder: 'Select Confidence Group',
        controlType: { name: 'dropdown', isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'ZyhUcm2N5aPqL4r',
    groupBy: 'Synchronizer',
    name: 'Recommendation Review Reason',
    tooltip: 'Human-readable reason for any low-confidence recommendation review signal.',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg105',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'Vt95PqLFu4hNwRm',
        filterLabel: '',
        comparisonOperator: 'contains',
        type: 'regex',
        field: 'recommendationReviewReason',
        collection: 'synchronizer_results',
        placeholder: 'Review Reason',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: false,
        renderStringOperator: false,
        renderTextOperator: true,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'UksfKZiuaziFjhAb',
    groupBy: 'Synchronizer',
    name: 'Performance Relative to Target',
    tooltip: 'Synchronizer performance relative to target. Use Range operator for range queries.',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg103',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'kia7t6w8yaiAhaq',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'performanceRelativeToTarget',
        collection: 'synchronizer_results',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Draft Titles',
    name: 'Fixed shared draft',
    parentId: 'fixedSharedDraftBusinessRule',
    tooltip:
      'The trigger should only include titles whose shared-draft date window is active / matches the trigger run date',
    renderNATypes: false,
    isFrequentlyUsed: true,
    shortCode: 'arg104',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'fixedSharedDraftBusinessRuleValue',
        filterLabel: 'Fixed shared draft',
        collection: 'shareddraft',
        placeholder: 'Select Fixed Shared Draft',
        comparisonOperator: '$in',
        type: 'ObjectId',
        field: 'fixedSharedDraftId',
        controlType: { name: 'dropdown', isMulti: true, isDataStoredInValue: true, isRequired: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    groupBy: 'Title Metadata',
    name: 'Top 100',
    parentId: 'jClpz2FrCB4x6Nrr',
    tooltip: 'Checks for Top 100 Title Yes or No',
    renderNATypes: false,
    isFrequentlyUsed: false,
    shortCode: 'arg107',
    display: ['triggerBusinessRule'],
    childFilters: [
      {
        _id: 'ayarmTuCCUaou55s',
        filterLabel: '',
        comparisonOperator: '$eq',
        type: 'Boolean',
        field: 'isTop100',
        collection: 'books',
        placeholder: 'Is top 100?',
        controlType: {
          name: 'dropdown',
          isMulti: false,
          isDataStoredInValue: true,
          checkBoolean: true,
        },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
  {
    parentId: 'Yganskass6Ua',
    groupBy: 'Ignition & Publisher Support',
    name: 'Estimated Monthly Uplift',
    tooltip: '(Estimated Campaign Revenue + Prorated Title Full-Month Uplift)',
    isFrequentlyUsed: false,
    shortCode: 'arg109',
    display: ['triggerBusinessRule'],
    isRelativeChildFilters: true,
    isCalculatedField: true,
    field: 'US.campaignTypePerformanceData.[campaigntype].estimatedMonthlyUplift',
    collection: 'bookdata',
    childFilters: [
      {
        _id: 'IhaRtvEueyAgGAHDa',
        filterLabel: '',
        comparisonOperator: '$gte',
        type: 'Range',
        field: 'campaignTypePerformanceData.estimatedMonthlyUplift',
        collection: 'bookdata',
        placeholder: 'Number',
        controlType: { name: 'inputbox', isRequired: true, type: 'string' },
        renderCompOperator: true,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignFilter: false,
        isCalculatedField: false,
        isPostProcessingFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
      {
        _id: 'hNAMgT9asbatlY_8Yba',
        filterLabel: '',
        comparisonOperator: '$in',
        type: 'Array',
        field: 'campaigntype',
        collection: 'campaigntypes',
        placeholder: 'Select Campaign Type',
        controlType: { name: 'dropdown', isDataStoredInValue: true },
        renderCompOperator: false,
        renderStringOperator: false,
        isCountryBasedData: false,
        isCampaignExclusionFilter: false,
        isCalculatedField: true,
        isPostProcessingFilter: false,
        isBlockListExclusionFilter: false,
        isThemedFilter: false,
        isKBDThemedFilter: false,
        isCustomCategoryDynamicFilter: false,
      },
    ],
  },
];
